import { createSlice } from '@reduxjs/toolkit'

const initialState = localStorage.getItem("userEmail") || "";

const usuarioSlice = createSlice({
    name: 'nameUser',
    initialState,
    reducers: {
        setUserEmail: (state, action) => {
            const email = action.payload;
            let nomeUser = email;
            if (typeof email === 'string' && email.includes('@')) {
                nomeUser = email.split('@')[0];
                if (nomeUser.length > 0) {
                    nomeUser = nomeUser.charAt(0).toUpperCase() + nomeUser.slice(1);
                }
            }
            localStorage.setItem("userEmail", email);
            return nomeUser;
        },
    }
})

export const { setUserEmail } = usuarioSlice.actions;

export default usuarioSlice.reducer
